module.exports = __webpack_public_path__ + "static/media/AFL.10d0ae66.svg";